import React from "react";

const EventsPageLoader = () => {
  return (
    <div className="p-4">
      {/* Header skeleton */}
      <div className="flex justify-between items-center mb-6 animate-pulse">
        <div className="h-6 w-40 bg-gray-300 rounded" />
        <div className="h-10 w-32 bg-gray-300 rounded" />
      </div>

      {/* Card grid skeleton */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm space-y-4 animate-pulse"
          >
            <div className="h-48 bg-gray-300 rounded-md" />
            <div className="h-4 bg-gray-300 rounded w-3/4" />
            <div className="h-3 bg-gray-200 rounded w-full" />
            <div className="h-3 bg-gray-200 rounded w-5/6" />
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 rounded w-2/3" />
              <div className="h-3 bg-gray-200 rounded w-1/3" />
              <div className="h-3 bg-gray-200 rounded w-1/2" />
            </div>
            <div className="h-10 bg-gray-300 rounded w-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsPageLoader;
